import { PaymentModel } from './models/payment.model';
import AppHttpClient from '../api-manager/api/http-client';
import HttpPathsEnum from '../api-manager/api/http-paths.enum';
import { HttpRequest, RequestType } from '../api-manager/api/http-request';
import { MyActivitiesType } from '../../store/my-activities/myActivitiesTypes';
import { GetMyActivitiesEventResponseDto } from './responses/get-my-activities-event.response.dto';
import { GetMyActivitiesResourceResponseDto } from './responses/get-my-activities-resource.response.dto';

const EVENTS_PATH = HttpPathsEnum.EVENTS;
const RESOURCE_PATH = HttpPathsEnum.RESOURCE;

class MyActivitiesApi {
  public async getEventMyActivities(
    type: MyActivitiesType,
    take: number,
    skip: number
  ) {
    const request: HttpRequest = {
      url: `${EVENTS_PATH}/event/my-activities/${type}?take=${take}&skip=${skip}`,
      method: RequestType.GET,
    };

    return await AppHttpClient.exec<any, GetMyActivitiesEventResponseDto>(
      request,
      GetMyActivitiesEventResponseDto
    );
  }

  public async getResourceMyActivities(
    type: MyActivitiesType,
    take: number,
    skip: number
  ) {
    const request: HttpRequest = {
      url: `${RESOURCE_PATH}/resource-alloc/my-activities/${type}?take=${take}&skip=${skip}`,
      method: RequestType.GET,
    };

    return await AppHttpClient.exec<any, GetMyActivitiesResourceResponseDto>(
      request,
      GetMyActivitiesResourceResponseDto
    );
  }

  public async getOrderPaymentsById(id: number) {
    const request: HttpRequest = {
      url: `${RESOURCE_PATH}/payment/get-payments-by-id/${id}`,
      method: RequestType.GET,
    };

    return await AppHttpClient.exec<any, PaymentModel[]>(request, PaymentModel);
  }
}

///Store -> getPaymentsOrdersById
export default new MyActivitiesApi();
